import reduxApi from 'redux-api';
import customFetch from 'api/axios';
import { API_URL, checkServerLive } from 'constants/config';

// Example
export default reduxApi({
  getDetailReception: {
    url: `${API_URL}/soTiepCongDans/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getphanLoaiNguoiDungDon: {
    url: `${API_URL}/phanLoaiNguoiDungDons`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getLichSuTrangThaiXLGQDons: {
    url: `${API_URL}/lichSuTrangThaiXuLyGiaiQuyetDonTheoDoiDonDocs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDoiTuongBKT: {
    url: `${API_URL}/loaiDoiTuongBiKhieuTos`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getHuongXuLyTCD: {
    url: `${API_URL}/huongXuLyTCDs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getHuongGiaiQuyet: {
    url: `${API_URL}/huongGiaiQuyetCuaLanhDaoTCDs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getTiepCongDan: {
    url: `${API_URL}/soTiepCongDans`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTiepCongDanDinhKy: {
    url: `${API_URL}/soTiepCongDans?loaiTiepCongDan=DINH_KY&page=:page&size=:size&sort=id,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  gethoSoVuViec: {
    url: `${API_URL}/hoSoVuViecYeuCauGapLanhDaos?page=:page&size=:size&sort=ngayTiepNhan,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiTepDK: {
    url: `${API_URL}/loaiTepDinhKems?page=0&size=1000&sort=ngayTao,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getListLanhDao: {
    url: `${API_URL}/lanhDaoTiepCongDans?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getHuongGiaiQuyetLD: {
    url: `${API_URL}/huongGiaiQuyetCuaLanhDaoTCDs?page=0&size=1000&sort=ngayTao,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getTiepCongDanDotXuat: {
    url: `${API_URL}/soTiepCongDans?loaiTiepCongDan=DOT_XUAT&page=:page&size=:size&sort=id,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getTinhTrangTaiLieu: {
    url: `${API_URL}/tinhTrangTaiLieus`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getTinhTrangXuLy: {
    url: `${API_URL}/tinhTrangXuLyCuaLanhDaoTCDs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getKetQuaTiepDan: {
    url: `${API_URL}/huongGiaiQuyetCuaLanhDaoTCDs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getKetQuaTiepDanSearch: {
    url: `${API_URL}/huongGiaiQuyetCuaLanhDaoTCDs/timKiem`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  searchTiepCongDan: {
    url: `${API_URL}/soTiepCongDans?tuKhoa=:tuKhoa&loaiTiepCongDan=THUONG_XUYEN&page=:page&size=:size&sort=ngayTao,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  superSearchTiepCongDan: {
    url: `${API_URL}/soTiepCongDans?loaiTiepCongDan=THUONG_XUYEN&tuKhoa=:tuKhoa&phanLoaiDon=:phanLoaiDon&huongXuLy=:huongXuly&page=:page&size=:size&sort=ngayTao,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  searchTiepCongDanDinhKy: {
    url: `${API_URL}/soTiepCongDans?tuKhoa=:tuKhoa&loaiTiepCongDan=DINH_KY&page=:page&size=:size&sort=ngayTao,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  superSearchTiepCongDanDinhKy: {
    url: `${API_URL}/soTiepCongDans?loaiTiepCongDan=DINH_KY&tuKhoa=:tuKhoa&phanLoaiDon=:phanLoaiDon&huongXuLy=:huongXuly&page=:page&size=:size&sort=ngayTao,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  searchTiepCongDanDotXuat: {
    url: `${API_URL}/soTiepCongDans?tuKhoa=:tuKhoa&loaiTiepCongDan=DOT_XUAT&page=:page&size=:size&sort=ngayTao,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  superSearchTiepCongDanDotXuat: {
    url: `${API_URL}/soTiepCongDans?loaiTiepCongDan=DOT_XUAT&tuKhoa=:tuKhoa&phanLoaiDon=:phanLoaiDon&huongXuLy=:huongXuly&page=:page&size=:size&sort=ngayTao,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDungDon: {
    url: `${API_URL}/phanLoaiNguoiDungDons?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getDanToc: {
    url: `${API_URL}/danTocs?page=0&size=1000&sort=ten,asc&cha=:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getToDanPho: {
    url: `${API_URL}/toDanPhos?page=0&size=1000&sort=ten,asc&donViHanhChinh=:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getListCapPhuongXa: {
    url: `${API_URL}/donViHanhChinhs?page=0page&size=1000&sort=ten,asc&cha=:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getCapQuanHuyen: {
    url: `${API_URL}/donViHanhChinhs/capQuanHuyen?page=0&size=1000&sort=ten,asc&cha=:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getCapTinhThanhPho: {
    url: `${API_URL}/donViHanhChinhs/capTinhThanhPho?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDonThu: {
    url: `${API_URL}/loaiDonThus?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getHuongXuLy: {
    url: `${API_URL}/huongXuLyTCDs?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDoiTuong: {
    url: `${API_URL}/loaiDoiTuongs?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getLinhVucDonThu: {
    url: `${API_URL}/linhVucDonThus?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCapCoQuan: {
    url: `${API_URL}/capCoQuanQuanLys/capCoQuanDaGiaiQuyets?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonViChuTri: {
    url: `${API_URL}/coQuanQuanLys/donViChuTris?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },

  getLichSuTrangThaiXuLyGiaiQuyetDon: {
    url: `${API_URL}/lichSuTrangThaiXuLyGiaiQuyetDons`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },


  getCoQuan: {
    url: `${API_URL}/coQuanQuanLys/coQuanDaGiaiQuyets?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCoQuanDetail: {
    url: `${API_URL}/coQuanQuanLys/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getIdThanhPhoDN: {
    url: `${API_URL}/thamSos?tuKhoa=DVHC_TP_DA_NANG`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getCoQuanQLTPDN: {
    url: `${API_URL}/thamSos?tuKhoa=CQQL_UBNDTP_DA_NANG`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },

  getThamQuyen: {
    url: `${API_URL}/thamQuyenGiaiQuyets?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getCongDanExist: {
    url: `${API_URL}/congDanExists`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCMNDExist: {
    url: `${API_URL}/cmndExists`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getHinhThucGiaiQuyet: {
    url: `${API_URL}/hinhThucDaGiaiQuyet?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDoiTuongBiKhieuTo: {
    url: `${API_URL}/loaiDoiTuongBiKhieuTos?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  searchCongDan: {
    url: `${API_URL}/congDanBySuggests`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postDon: {
    url: `${API_URL}/dons`,
    options: (url, params, getState) => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'POST',
        data: {
          ...params,
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        }
      };
    }
  },
  postDonCu: {
    url: `${API_URL}/donCus`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateDon: {
    url: `${API_URL}/dons/:id`,
    options: (url, params, getState) => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'PATCH',
        data: {
          ...params,
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        }
      };
    }
  },
  updateDonCu: {
    url: `${API_URL}/donCus/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  postDonCongDan: {
    url: `${API_URL}/donCongDans`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateDonCongDan: {
    url: `${API_URL}/donCongDans/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  postCongDan: {
    url: `${API_URL}/congDans`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateCongDan: {
    url: `${API_URL}/congDans/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  postTaiLieuBangChung: {
    url: `${API_URL}/taiLieuBangChungs`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateTaiLieuBangChung: {
    url: `${API_URL}/taiLieuBangChungs/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  postSoTiepCongDan: {
    url: `${API_URL}/soTiepCongDans`,
    options: (url, params, getState) => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'POST',
        data: {
          ...params,
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        }
      };
    }
  },
  updateSoTiepCongDan: {
    url: `${API_URL}/soTiepCongDan/:id`,
    options: (url, params, getState) => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'PATCH',
        data: {
          ...params,
          donViId: userInfo ? userInfo.donViId : '',
          congChucId: userInfo ? userInfo.id : ''
        }
      };
    }
  },
  getCongchucOfUser: {
    url: `${API_URL}/congChucs/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getNguoiDaiDienCoQuan: {
    url: `${API_URL}/congChucs/:id/thuocDonVi`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getSoTiepCongDanDetail: {
    url: `${API_URL}/soTiepCongDans/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getSoTiepCongDanInfo: {
    url: `${API_URL}/soTiepCongDan/:id/infos`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonInfo: {
    url: `${API_URL}/dons/:id/infos`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonCuInfo: {
    url: `${API_URL}/donCus/:id/infos`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getcongDan: {
    url: `${API_URL}/congDans/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getDanhSachDonCDId: {
    url: `${API_URL}/congDans/:id/danhSachDons?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getDanhSachDonCuCDId: {
    url: `${API_URL}/congDans/:id/danhSachDonCus?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  deleteTiepCongDan: {
    url: `${API_URL}/soTiepCongDans/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteTiepCongDanDinhKy: {
    url: `${API_URL}/soTiepCongDans/:id/huyCuocTiepDanDinhKyCuaLanhDao`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteDonCongDan: {
    url: `${API_URL}/donCongDans/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteTaiLieuBangChung: {
    url: `${API_URL}/taiLieuBangChungs/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteTepDinhKem: {
    url: `${API_URL}/taiLieuVanThus/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteTepDinhKemUyQuyen: {
    url: `${API_URL}/tepDinhKems/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  updateTaiLieuVanThu: {
    url: `${API_URL}/taiLieuVanThus/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'PATCH',
        data: _params
      };
    }
  },
  postTaiLieuVanThu: {
    url: `${API_URL}/taiLieuVanThus`,
    options: (url, _params, getState) => {
      return {
        method: 'POST',
        data: _params
      };
    }
  },
  postFileUpload: {
    url: `${API_URL}/documents/uploadfile`,
    options: (url, _params, getState) => {
      let formData = new FormData();
      formData.append(_params.field, _params.file);
      return {
        method: 'POST',
        data: formData,
        onUploadProgress: function (progressEvent) {
          _params.progress(progressEvent);
        }
      };
    }
  },
  postFileUploadExcelData: {
    url: `${API_URL}/cuoc-thanh-kiem-tra/process-excel-data`,
    options: (url, _params, getState) => {
      let formData = new FormData();
      formData.append(_params.field, _params.file);
      return {
        method: 'POST',
        data: formData,
      };
    }
  },
  postImportDoiTuongThanhTra: {
    url: `${API_URL}/doi-tuong-thanh-tra/import`,
    options: (url, _params, getState) => {
      let formData = new FormData();
      formData.append(_params.field, _params.file);
      return {
        method: 'POST',
        data: formData,
        onUploadProgress: function (progressEvent) {
          _params.progress(progressEvent);
        }
      };
    }
  },
  postDownloadDsLoiDoiTuongThanhTra: {
    url: `${API_URL}/doi-tuong-thanh-tra/import`,
    options: (url, _params, getState) => {
      let formData = new FormData();
      formData.append(_params.field, _params.file);
      return {
        method: 'POST',
        data: formData,
        responseType: "blob",
        onUploadProgress: function (progressEvent) {
          _params.progress(progressEvent);
        }
      };
    }
  },
  postImportCuocKiemTra: {
    url: `${API_URL}/cuoc-thanh-kiem-tra/validation-export`,
    options: (url, _params, getState) => {
      let formData = new FormData();
      formData.append(_params.field, _params.file);
      return {
        method: 'POST',
        data: formData,
        responseType: "blob",
        onUploadProgress: function (progressEvent) {
          _params.progress(progressEvent);
        }
      };
    }
  },
  postFileUploadHDSD: {
    url: `${API_URL}/documents/uploadHDSD`,
    options: (url, _params, getState) => {
      let formData = new FormData();
      formData.append(_params.field, _params.file);
      return {
        method: 'POST',
        data: formData,
        onUploadProgress: function (progressEvent) {
          _params.progress(progressEvent);
        }
      };
    }
  },
  postDonCongDanMulti: {
    url: `${API_URL}/donCongDans/multi`,
    options: (url, params, getState) => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'POST',
        data: {
          ...params,
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        }
      };
    }
  },
  postDoanDiCungMulti: {
    url: `${API_URL}/doanDiCungs/multi`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postTaiLieuBangChungMulti: {
    url: `${API_URL}/taiLieuBangChungs/multi`,
    options: (url, params, getState) => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'POST',
        data: {
          ...params,
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        }
      };
    }
  },
  updateDonCongDanMulti: {
    url: `${API_URL}/donCongDans/multi`,
    options: (url, params, getState) => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'PATCH',
        data: {
          ...params,
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        }
      };
    }
  },
  updateDoanDiCungMulti: {
    url: `${API_URL}/doanDiCungs/multi`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  deleteDoanDiCungMulti: {
    url: `${API_URL}/doanDiCungs/multi`,
    options: (url, params, getState) => {
      return {
        method: 'DELETE',
        data: params
      };
    }
  },
  deleteTaiLieuVanThuMulti: {
    url: `${API_URL}/taiLieuVanThus/multi`,
    options: (url, params, getState) => {
      return {
        method: 'DELETE',
        data: params
      };
    }
  },
  updateTaiLieuBangChungMulti: {
    url: `${API_URL}/taiLieuBangChungs/multi`,
    options: (url, params, getState) => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'PATCH',
        data: {
          ...params,
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        }
      };
    }
  },
  postTaiLieuVanThuMulti: {
    url: `${API_URL}/taiLieuVanThus/multi`,
    options: (url, params, getState) => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'POST',
        data: {
          ...params,
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        }
      };
    }
  },
  postTepDinhKemMulti: {
    url: `${API_URL}/tepDinhKems/multi`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateTepDinhKemMulti: {
    url: `${API_URL}/tepDinhKems/multi`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateTaiLieuVanThuMulti: {
    url: `${API_URL}/taiLieuVanThus/multi`,
    options: (url, params, getState) => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'PATCH',
        data: {
          ...params,
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        }
      };
    }
  },
  getTrangThaiYeuCau: {
    url: `${API_URL}/tiepCongDan/trangThaiYeuCauGapLanhDao?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDanhSachYeuCau: {
    url: `${API_URL}/danhSachYeuCauGapLanhDaoDinhKys`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  updateXuLyYeuCau: {
    url: `${API_URL}/soTiepCongDan/:id/capNhatTrangThaiYeuCauGapLanhDao`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  getDonViNgoaiHeThong: {
    url: `${API_URL}/donViNgoaiHeThongs/danhSachDonViTimKiems`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  importFileDoiTuong: {
    url: `${API_URL}/doiTuongThanhTra/import-excel`,
    options: (url, _params, getState) => {
      const formData = new FormData();
      formData.append(_params.field, _params.file);
      return {
        method: 'POST',
        data: formData
      };
    }

  }
}).use('fetch', customFetch);



// WEBPACK FOOTER //
// ./src/api/reception.js